import { computed, readonly } from 'vue';

import { appStorageController } from '../app-storage';
import {
  CookieConsentCategory,
  CookieConsentDecision,
  type CookieConsentController,
  type CookieConsentStorage,
} from './types';

const createCookieConsentController = (storage: CookieConsentStorage): CookieConsentController => {
  const decision = readonly(storage.notRequiredCookieConsent);
  const isChoiceRequired = computed<boolean>(() => decision.value === null);
  const isNotRequiredAllowed = computed<boolean>(
    () => decision.value === CookieConsentDecision.ACCEPTED,
  );

  const isAllowed = (category: CookieConsentCategory): boolean => {
    if (category === CookieConsentCategory.NOT_REQUIRED) {
      return isNotRequiredAllowed.value;
    }

    return false;
  };

  const acceptNotRequired = (): void => {
    storage.setNotRequiredCookieConsent(CookieConsentDecision.ACCEPTED);
  };

  const rejectNotRequired = (): void => {
    storage.setNotRequiredCookieConsent(CookieConsentDecision.REJECTED);
  };

  return {
    acceptNotRequired,
    decision,
    isAllowed,
    isChoiceRequired,
    isNotRequiredAllowed,
    rejectNotRequired,
  };
};

const cookieConsentController: CookieConsentController =
  createCookieConsentController(appStorageController);

export { cookieConsentController, createCookieConsentController };
